import { render, staticRenderFns } from "./playgroundDetail.vue?vue&type=template&id=0a28685e&scoped=true&"
import script from "./playgroundDetail.vue?vue&type=script&lang=js&"
export * from "./playgroundDetail.vue?vue&type=script&lang=js&"
import style0 from "./playgroundDetail.vue?vue&type=style&index=0&id=0a28685e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a28685e",
  null
  
)

export default component.exports